import { createTermTagManager } from '../../utils/createTermTagManager';

export const multiIdTagManager = createTermTagManager({
  jsonQueryKey: 'multi_id',
  template: `Мультиобъявление №%s`,
  id: 'multiId',
});
